import React, { ReactNode } from 'react';
import { StyledPageBody, ErrorPageContent } from './ErrorPageRoot.styles';

interface ErrorPageRootProps {
  children: ReactNode;
}

export const ErrorPageRoot: React.FC<ErrorPageRootProps> = ({ children }) => {
  return (
    <StyledPageBody>
      <ErrorPageContent>{children}</ErrorPageContent>
    </StyledPageBody>
  );
};
